import { useContext } from 'react';

import { useMutation, useQueryClient } from 'react-query';

import { AlertSnackbarContext } from '../../../components/snackbars';
import { Post } from '../../../types/Post';
import Api from '../../api/api';

export const recommendPost = async (postId: string): Promise<Post> => {
  const [response, bodyOrError] = await Api.patch(`posts/${postId}/recommend-post`);

  if (!response.ok) {
    throw bodyOrError;
  }

  return response;
};

export const useRecommendPost = () => {
  const queryClient = useQueryClient();
  const [, setAlertSnackbar] = useContext(AlertSnackbarContext);

  return useMutation(
    'recommendPost',
    (data: { postId: string }) => {
      return recommendPost(data.postId);
    },
    {
      onSuccess: () => {
        setAlertSnackbar({
          message: 'Added as recommended Post',
          severity: 'success',
          vertical: 'top',
        });
        queryClient.invalidateQueries(['getPostById']);
      },
    },
  );
};
